import lightTheme from '../components/style/lightTheme';

const MuiDivider = {
  styleOverrides: {
    root: {
      '&.MuiDivider-thick': {
        borderColor: lightTheme.borderStrong,
      },
    },
  },
};

export default MuiDivider;
